'use client'

import { Divider } from '@vinted/web-ui'

import { ITEM_UPLOAD_URL, CATALOG_URL } from 'constants/routes'
import { FaqEntryType } from 'constants/faq-entry'

import { useTranslate } from '@marketplace-web/shared/i18n'

import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'

import HowItWorksHeader from './HowItWorksHeader'
import HowItWorksSteps from './HowItWorksSteps'
import { HowToStepItemModel } from './types'
import HowItWorksActions from './HowItWorksActions'
import HowItWorksBuyerProtection from './HowItWorksBuyerProtection'

const HOW_TO_SELL_STEPS: Array<HowToStepItemModel> = [
  {
    image: 'how-to-sell-step1.png',
    titleKey: 'how_to_sell.step_1.title',
    descriptionKey: 'how_to_sell.step_1.description',
    learnMoreEntry: FaqEntryType.UploadingAnItem,
  },
  {
    image: 'how-to-sell-step2.png',
    titleKey: 'how_to_sell.step_2.title',
    descriptionKey: 'how_to_sell.step_2.description',
    learnMoreEntry: FaqEntryType.ShippingSeller,
  },
  {
    image: 'how-to-sell-step3.png',
    titleKey: 'how_to_sell.step_3.title',
    descriptionKey: 'how_to_sell.step_3.description',
    learnMoreEntry: FaqEntryType.VintedWallet,
  },
]

const HOW_TO_BUY_STEPS: Array<HowToStepItemModel> = [
  {
    image: 'shopping-step1.png',
    titleKey: 'how_to_buy.step_1.title',
    descriptionKey: 'how_to_buy.step_1.description',
    learnMoreEntry: FaqEntryType.FindingAnItem,
  },
  {
    image: 'shopping-step2.png',
    titleKey: 'how_to_buy.step_2.title',
    descriptionKey: 'how_to_buy.step_2.description',
    learnMoreEntry: FaqEntryType.BuyingStepByStep,
  },
  {
    image: 'shopping-step3.png',
    titleKey: 'how_to_buy.step_3.title',
    descriptionKey: 'how_to_buy.step_3.description',
    learnMoreEntry: FaqEntryType.ShippingBuyer,
  },
]

const HowItWorks = () => {
  const translate = useTranslate('how_it_works')

  return (
    <>
      <HowItWorksHeader />
      <SeparatedList separator={<Divider />}>
        <HowItWorksSteps
          steps={HOW_TO_SELL_STEPS}
          title={translate('how_to_sell.title')}
          buttonTitle={translate('start_selling')}
          buttonUrl={ITEM_UPLOAD_URL}
          showTopTear
        />
        <HowItWorksSteps
          steps={HOW_TO_BUY_STEPS}
          title={translate('how_to_buy.title')}
          buttonTitle={translate('start_shopping')}
          buttonUrl={CATALOG_URL}
        />
        <HowItWorksBuyerProtection />
      </SeparatedList>
      <HowItWorksActions startShoppingUrl={CATALOG_URL} startSellingUrl={ITEM_UPLOAD_URL} />
    </>
  )
}

export default HowItWorks
